module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7efc16240b399536e9f33961b23ebabd.png";